function totalPriceCalculator() {
  const inputValue = addonInput.value || '';
  const priceMatches = [...inputValue.matchAll(/([^\d\s]+)?([\d,]+\.\d{2})/g)];
  let total = 0, currency = '£';
  for (const [, symbol, amount] of priceMatches) {
    if (symbol) currency = symbol;
    total += parseFloat(amount.replace(/,/g, ''));
  }
  if (total > 0) {
    addonTotal.style.display = 'block';
    addonTotal.querySelector('span').textContent = `${currency}${total.toFixed(2)})`;
  } else {
    addonTotal.style.display = 'none';
  }
}
async function syncCartItems() {
  const selectedCounts = {};
  addons.forEach(item => {
    const addonProduct = document.querySelector(`input[value="${item.variantId}"]`);
    const type = addonProduct?.nextElementSibling?.value;
    if (type) selectedCounts[type] = (selectedCounts[type] || 0) + 1;
  });
  document.querySelectorAll(".gifting-itemCount").forEach(span => {
    const type = span.classList[1];
    span.textContent = selectedCounts[type] || 0;
  });
  totalPriceCalculator();
}
//  Add on Info 
document.querySelectorAll('quick-add-modal').forEach(modal => document.body.append(modal));
let activeModal = null;
const popupOpen = id => {
  event.stopPropagation();
  if (activeModal) popupClose(activeModal.dataset.id);
  const modal = document.querySelector(`#QuickAdd-${id}`);
  const imageUrl = modal.querySelector('.product-addon-popupimgurl');
  const loader = modal.querySelector('.product-addon-popupleft .loading__spinner');
  modal.style.cssText = "visibility:visible;opacity:1;z-index:10";
  modal.dataset.id = id;
  document.body.style.overflow = "hidden";
  activeModal = modal;
  if (!modal.querySelector('.product-addon-popupimg')) {
    loader?.classList.remove('hidden');
    const img = new Image();
    img.src = "https://www.flowerstation.co.uk/cdn/shop/" + imageUrl.innerHTML;
    img.className = "product-addon-popupimg";
    img.onload = () => loader?.classList.add('hidden');
    imageUrl.after(img);
  }
};
const popupClose = id => {
  const modal = document.querySelector(`#QuickAdd-${id}`);
  modal.style.cssText = "visibility:hidden;opacity:0;z-index:-1";
  modal.querySelector('.product-addon-popupimg')?.remove();
  activeModal = null;
  document.body.style.overflow = "";
};
// Add on Storing in Array
const addons = []
const addonTotal = document.querySelector('.addon-totalprice');
const addonInput = document.querySelector('input[name="properties[Add Ons]"]');
function addAddon(button, productId, event, isQuickAdd = false) {
  const card = button.querySelector('.card');
  if (card.classList.contains('checked') && !isQuickAdd) {
    removeAddon(button);
    return;
  }
  event.preventDefault();
  const formParent = document.querySelector(`product-form[data-product-id="${productId}"]`);
  const form = formParent?.querySelector('form');
  if (!form) return;
  const selectedVariant = form.querySelector('input[name="id"], select[name="id"]');
  const variantId = selectedVariant?.value;
  if (!variantId) return;
  if (!addons.some(a => a.variantId === variantId)) {
    addons.push({ variantId });
    const title = button.getAttribute('data-title');
    const price = button.getAttribute('data-price');
    const variant = form.querySelector('option[value="' + variantId + '"]');
    const addonPrevValue = addonInput.value || '';
    if( variant) {
      const varianttext = variant.textContent.trim();
      const [variantTitle, variantPrice] = varianttext.split(' - ');
      addonInput.value = addonPrevValue ? addonPrevValue + "," + title +" Variant[" + variantTitle + "]" + " (" + variantPrice + ")" : title +" Variant[" + variantTitle + "]" + " (" + variantPrice + ")";
    } else {
      addonInput.value = addonPrevValue ? addonPrevValue + "," + title + " (" + price + ")" : title + " (" + price + ")";
    }
  }
  formParent.closest('.card')?.classList.add('checked');
  syncCartItems();
}
function removeAddon(element) {
  const ids = JSON.parse(element.getAttribute('data-item')).map(String);
  const title = element.getAttribute('data-title');
  ids.forEach(id => {
    const i = addons.findIndex(a => a.variantId === id);
    if (i !== -1) addons.splice(i, 1);
  });
  const currentValue = addonInput?.value || '';
  const values = currentValue.split('),').map(v => v.trim());
  const filtered = values.filter(v => !v.startsWith(title));
  addonInput.value = filtered.join('), ');
  element.parentElement.querySelector('.card')?.classList.remove('checked');
  if (addonInput.value[addonInput.value.length - 1] !== ')' && addonInput.value.length > 0) {
    addonInput.value += ')';
  }
  syncCartItems();
}
// Handle Submit the Original Product
const formButton = document.querySelector('.product-form__submit');
const form = formButton.closest('form');
const originalProductTitle = document.querySelector('.product__title h1')?.innerText || 'Main Product';
formButton.addEventListener('click', async (e) => {
  if (addons.length === 0) return;
  e.preventDefault();
  const uniqueId = Date.now().toString() + Math.floor(Math.random() * 10000).toString();
  const uniqueIdInput = document.querySelector('input[name="properties[addonId]"]');
  if (uniqueIdInput) uniqueIdInput.value = uniqueId;
  formButton.style.pointerEvents = 'none';
  formButton.style.opacity = '0.5';
  formButton.querySelector('.loading__spinner')?.classList.remove('hidden');
  for (let addon of addons) {
    const variantId = Number(addon.variantId);
    if (!variantId || isNaN(variantId)) continue;
    const variantPicker = document.querySelector(`input[value="${variantId}"]`);
    const addOnType = variantPicker?.nextElementSibling?.value;
    const formData = {
      items: [{
        id: variantId,
        quantity: 1,
        properties: {
          'Addon Of': originalProductTitle,
          'Type': addOnType,
          'uniqueId': uniqueId
        }
      }]
    };
    try {
      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(formData)
      });
    } catch (error) {
      console.error('Error adding addon:', error);
    }
  }
  addons.length = 0;
  setTimeout(() => {
    removeAddonFromInput();
  })
  syncCartItems();
  formButton.style.pointerEvents = 'auto';
  formButton.style.opacity = '1';
  formButton.querySelector('.loading__spinner')?.classList.add('hidden');
  document.querySelectorAll('.card').forEach(card => card.classList.remove('checked'));
  const event = new Event('submit', { bubbles: true, cancelable: true });
  form.dispatchEvent(event);
});
function removeAddonFromInput() {
  const addonInput = document.querySelector('input[name="properties[Add Ons]"]');
  const addonId = document.querySelector('input[name="properties[addonId]"]');  
  if (addonInput) {
    addonInput.value = '';
  }
  if (addonId) {
    addonId.value = '';
  }
  syncCartItems();
}
// Removing Add on on removing original product
document.querySelector('.home-cart-drawer')?.addEventListener('click', async (e) => {
  const closeBtn = e.target.closest('.drawer__close');
  if (closeBtn) {
    removeAddonFromInput();
  }
})
document.querySelectorAll('.quick-add-modal').forEach(modal => {
  modal.addEventListener('click', event => {
    event.stopPropagation();      
    if (!event.target.closest('.popup-quick-add')) {
      event.stopImmediatePropagation();
      if (activeModal) popupClose(activeModal.dataset.id);
    }
  });
});
document.querySelectorAll('.add-on-card .variant-select').forEach(select => {
  select.addEventListener('click', () => {
    event.stopPropagation();
  })
  select.addEventListener('click', (event) => {
    const item = select.closest('.custom-prod-card');
    const id = item.getAttribute('data-id');
    const idNum = Number(id);
    if (!idNum || isNaN(idNum)) return;
    // loop on all options of the select element and call removeAddon function'
    select.querySelectorAll('option').forEach(option => {
      if (!option.value || isNaN(option.value)) return;
      removeAddon(item);
    })
    addAddon(item, idNum, event, true);
    });
})
document.querySelectorAll('.add-on-card').forEach(cardWrapper => {
  if (cardWrapper.querySelectorAll('li').length === 1) {
    const li = document.createElement('li');
    cardWrapper.append(li);
  }
})